<template>
  <div>
    <form v-if="form" :id="id" :method="method">
      <slot />
    </form>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'ProForm',
  props: {
    form: { type: Boolean, default: false },
    id: { type: String, default: '' },
    method: { type: String, default: '' },
  },
  data() {
    return {
      inputFocus: false,
      components: [],
    };
  },

  created() {

  },

  mounted() {
    if (!this.$slots.default) return;
    this.$slots.default.forEach(i => {
      if (!this.inputFocus && _.has(i, 'componentInstance.$attrs.focus')) {
        this.inputFocus = true;
        $(i.elm).find('input').focus();
      }
    });
  },

  methods: {
    isValid() {
      this.components = [];
      let validate = true;
      this.$slots.default.map(i => this.getComponents(i));

      this.components.forEach(component => {
        if (component && component.formValidation)
          if (!component.isValid && validate) validate = false;
      });
      return validate;
    },
    getComponents(i) {
      if (_.get(i, 'componentInstance')) this.setComponent(i.componentInstance);

      if (!_.isEmpty(i.children)) this.mapChildren(i.children);

      if (_.get(i, '$vnode')) {
        if (_.get(i.$vnode, 'componentInstance')) this.setComponent(i.$vnode.componentInstance);
        if (!_.isEmpty(i.$vnode.children)) this.mapChildren(i.$vnode.children);
      }

      if (!_.isEmpty(i.$children)) this.mapChildren(i.$children);
    },
    setComponent(componentInstance) {
      this.components.push(componentInstance);
      if (!_.isEmpty(componentInstance.$children)) componentInstance.$children.map(j => this.getComponents(j));
    },
    mapChildren(children) {
      children.forEach(j => {
        if (_.get(j, 'componentInstance')) this.setComponent(j.componentInstance);
        if (!_.isEmpty(j.children)) j.children.map(a => this.getComponents(a));
      });
    },
  },
};
</script>

<style lang="scss">
</style>
